import React from 'react';
import { Link } from 'react-router-dom';
import
    { FormGroup
    , Breadcrumbs
} from '@germix/germix-react-core';

import Application from '../components/app/Application';
import { withTranslation, WithTranslation } from 'react-i18next';

interface Props extends WithTranslation
{
}
interface State
{
}

/**
 * @author Germán Martínez
 */
class RouteAbout extends React.Component<Props,State>
{
    render()
    {
        const { t } = this.props;

        return (
<Application>
    <FormGroup>
        <Breadcrumbs>
            <Link to='/'>{t('titles.home')}</Link>
            <Link to='/about'>{t('titles.about')}</Link>
        </Breadcrumbs>
        <br/>
    </FormGroup>
    <FormGroup>
        <h1>{t('titles.about')}</h1>
    </FormGroup>
    <FormGroup>
        {t('about.description')}
    </FormGroup>
</Application>
        );
    }
};
export default withTranslation('common')(RouteAbout);
